import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    CalificacionPregunta: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_CALIFICACIONES_PREGUNTAS = 'GET_ALL_CALIFICACIONES_PREGUNTAS'
const GET_CALIFIACION_PREGUINTA_BY_ID = 'GET_CALIFIACION_PREGUINTA_BY_ID'
const POST_CALIFIACION_PREGUINTA = 'POST_CALIFIACION_PREGUINTA'
const UPDATE_CALIFIACION_PREGUINTA = 'UPDATE_CALIFIACION_PREGUINTA'
const DELETE_CALIFIACION_PREGUINTA = 'DELETE_CALIFIACION_PREGUINTA'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllCalifiacionesPreguntas = createAsyncThunk(
    GET_ALL_CALIFICACIONES_PREGUNTAS,
    async () => {
        try {
            const fullUrl = host + `CalificacionPregunta/obtenerCalificacionesPreguntas`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las CalificacionPreguntas: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getCalificacionPreguntaById = createAsyncThunk(
    GET_CALIFIACION_PREGUINTA_BY_ID,
    async (idCalificacionPregunta) => {
        try {
            const fullUrl = host + `CalificacionPregunta/obtenerCalificacionPreguntaById/${idCalificacionPregunta}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertCalificacionPregunta = createAsyncThunk(
    POST_CALIFIACION_PREGUINTA,
    async (data) => {
        try {
            const fullUrl = host + `CalificacionPregunta/agregarCalificacionPregunta`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateCalificacionPregunta = createAsyncThunk(
    UPDATE_CALIFIACION_PREGUINTA,
    async (data) => {
        try {
            const fullUrl = host + `CalificacionPregunta/actualizarCalificacionPregunta`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteCalificacionPregunta = createAsyncThunk(
    DELETE_CALIFIACION_PREGUINTA,
    async (idCalificacionPregunta) => {
        try {
            const fullUrl = host + `CalificacionPregunta/eliminarCalificacionPregunta/${idCalificacionPregunta}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosCalificacionPreguntaSlice = createSlice({

    name: 'metodosCalificacionPreguntaSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllCalifiacionesPreguntas.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.CalificacionPregunta = payload.data.data

        },
        [getCalificacionPreguntaById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.CalificacionPregunta = payload.data.data
        },
        [insertCalificacionPregunta.fulfilled]: (state, { payload }) => {
            state.CalificacionPregunta = payload.data.data
        },

        [updateCalificacionPregunta.fulfilled]: (state, { payload }) => {

        },
        [deleteCalificacionPregunta.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosCalificacionPreguntaSlice.actions
export const CalificacionPreguntaReducer = metodosCalificacionPreguntaSlice.reducer